export default "__VITE_ASSET__rf1WErK3__"